import ParticipantRow from "./ParticipantRow";
import { Icons } from "../../../utils/icons";

export default function ParticipantsCard({
  participants,
  currentUserId,
  onStatusChange,
  onRemove,
}) {
  return (
    <div className="card">
      <div className="card-title">
        <Icons.Users />
        <h3>Participants ({participants.length})</h3>
      </div>

      <div className="available-users-grid">
        {participants.map((p) => (
          <ParticipantRow
            key={p.user_id}
            participant={p}
            isCurrentUser={p.user_id === currentUserId}
            onStatusChange={onStatusChange}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
}
